import { ResetWizard } from "@/shared/interfaces/ResetWizard.interface";
import { ResetWizardProperty } from "@/shared/interfaces/ResetWizardProperty";
import { get, set } from "lodash";

export default {
    namespaced: true,

    state: {
        applyChange: {
            type_of_transaction: false,
            property_type: false,
        } as ResetWizardProperty,
        field: "",
    },

    mutations: {
        setApplyChange: function(state: ResetWizard, value: boolean): void {
            set(state.applyChange, state.field, value);
        },
        setField: function(state: ResetWizard, value: string): void {
            state.field = value;
        }

    },

    getters: {
        getApplyChange: (state: ResetWizard) => (path:string): boolean => {
            return get(state.applyChange, path);
        },
        getField: (state: ResetWizard): string => {
            return state.field;
        }
    }
};
